module.exports = __webpack_public_path__ + "static/footer-back-wave-f638fe6cc1b67e34cad3939d10bde0e1.svg";